// Predefined list of music genres for artist profiles
export const MAX_ARTIST_GENRES = 5;

/** Normalize API artist row to a list of genre strings (supports legacy `genre`). */
export function artistGenresList(artist) {
  if (!artist) return [];
  if (Array.isArray(artist.genres)) return artist.genres;
  if (artist.genre) return [artist.genre];
  return [];
}

export const GENRES = [
  "Rock",
  "Pop",
  "Country",
  "Covers",
  "Reggae",
  "Acoustic",
  "Alternative",
  "DJ",
  "Karaoke",
  "Event",
  "Cover Band",
  "Tribute Band",
  "Jazz",
  "Blues",
  "Hip Hop",
  "R&B",
  "Electronic",
  "Folk",
  "Latin",
  "Classical",
  "Metal",
  "Punk",
  "Indie",
  "Soul",
  "Funk",
  "Gospel",
  "Bluegrass",
  "Other",
];

export default GENRES;
